import { useNavigate } from "react-router-dom";
import "../styles/NotFound.css";

export default function NotFound({ session }) {
   const nav = useNavigate();

  return (
    <div className="mainNotFound">
      <div className="notFoundContainer">
        <div className="main404">
          <div className="Letter404">4</div>
          <div className="Letter404">0</div>
          <div className="Letter404">4</div>
        </div>
        <p className="notFoundText">Page Not Found</p>  
        <p className="notFoundSubText">The page you are looking for was removed, moved, renamed, or might never have existed.</p>
        <div className="goHome" onClick={() => {nav(session ? "/documents" : "/"); window.location.reload();}}>{`Return ${session ? "To Documents" : "Home"}`}</div>
      </div>
    </div>
  );
}